import { HomeComponent }    from './public/home/home.component';
import { NgModule }         from '@angular/core'
import { CommonModule, }    from '@angular/common'
import { BrowserModule }    from '@angular/platform-browser'
import { Routes, RouterModule } from '@angular/router'
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component'
import { AuthGuardService } from './services/auth-guard.service';
import { SocialComponent } from './modules/social/social.component';
import { LoginComponent } from './public/login/login.component';
import { BillingComponent } from './modules/billing/billing.component';
import { GedComponent } from './modules/ged/ged.component';
import {GedLinkComponent} from './modules/ged/ged-link/ged-link.component';


const routes: Routes = [
  { path: 'link/:key',component:GedLinkComponent},
  { path: 'login', component: LoginComponent },
  { path: 'services/ged', component: GedComponent, canActivate: [AuthGuardService] },
  { path: 'services/:apiKey/social', component: SocialComponent, canActivate: [AuthGuardService] },
  { path: 'services/:apiKey/billing', component: BillingComponent, canActivate: [AuthGuardService] },
  { path: '', component: HomeComponent, canActivate: [AuthGuardService] },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
      }]
  }
]

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [

  ],
})
export class AppRoutingModule { }
